import { render, staticRenderFns } from "./ReportProjectSection.vue?vue&type=template&id=340281e1&scoped=true&"
import script from "./ReportProjectSection.vue?vue&type=script&lang=js&"
export * from "./ReportProjectSection.vue?vue&type=script&lang=js&"
import style0 from "./ReportProjectSection.vue?vue&type=style&index=0&id=340281e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340281e1",
  null
  
)

export default component.exports
import {QExpansionItem,QItemSection,QIcon,QItem} from 'quasar'
component.options.components = Object.assign({QExpansionItem,QItemSection,QIcon,QItem}, component.options.components || {})
